import {
  PATIENT_DRAWER_DETAILS,
  CLOSE_SHOW_PATIENT_DRAWER,
  SET_ACTIVE_TAB,
  SET_LOADING_PATIENT_DRAWER_DATA,
  SET_ERROR_PATIENT_DRAWER_DATA,
  SET_PATIENT_DRAWER_PATIENT_DETAILS,
  SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER,
  SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER
} from './Index';
import {getSpecificPatientDetails} from '../../services/PatientsServices';

export const _patientDrawerDetails = (
  groupId: number,
  clinicId: number,
  patientId: number,
  // Added optional parameter, active tab to select the default tab when patient drawer opens
  activeTab?: string,
  /** When set (e.g. from Voice Call Sessions grid), Appointments tab loads only this appointment. */
  focusedAppointmentId?: number | null
) => async (dispatch: any) => {
  const normalizedFocusId =
    focusedAppointmentId === undefined || focusedAppointmentId === null
      ? null
      : Number(focusedAppointmentId);
  const safeFocusId =
    normalizedFocusId != null &&
    Number.isFinite(normalizedFocusId) &&
    normalizedFocusId > 0
      ? normalizedFocusId
      : null;

  // Set early so Appointments tab can read focusedAppointmentId before patient details fetch finishes.
  dispatch({
    type: SET_LOADING_PATIENT_DRAWER_DATA,
    payload: {focusedAppointmentId: safeFocusId}
  });
  try {
    const res = await getSpecificPatientDetails(groupId, clinicId, patientId);
    dispatch({
      type: PATIENT_DRAWER_DETAILS,
      payload: {
        groupId: groupId,
        clinicId: clinicId,
        patientId: patientId,
        patientDetails: res?.data,
        activeTab: activeTab,
        focusedAppointmentId: safeFocusId
      }
    });
  } catch (err: any) {
    // In case of error, close the drawer
    dispatch({
      type: SET_ERROR_PATIENT_DRAWER_DATA,
      payload: err
    });
  }
};

export const _closePatientDrawer = () => async (dispatch: any) => {
  dispatch({
    type: CLOSE_SHOW_PATIENT_DRAWER
  });
};

export const _setActiveTab = (activeTab: string) => async (dispatch: any) => {
  dispatch({
    type: SET_ACTIVE_TAB,
    payload: {
      activeTab: activeTab
    }
  });
};

export const _setPatientDrawerPatientDetails = (
  groupId: number,
  clinicId: number | string,
  patientId: number
) => async (dispatch: any) => {
  try {
    const res = await getSpecificPatientDetails(groupId, clinicId, patientId);
    dispatch({
      type: SET_PATIENT_DRAWER_PATIENT_DETAILS,
      payload: {
        patientDetails: res?.data
      }
    });
  } catch (err: any) {
    dispatch({
      type: SET_ERROR_PATIENT_DRAWER_DATA,
      payload: err
    });
  }
};

export const _setEligibilityVerificationAppointmentPatientDrawer = (
  appointment: any
) => async (dispatch: any): Promise<void> => {
  dispatch({
    type: SET_ELIGIBILITY_VERIFICATION_APPOINTMENT_PATIENT_DRAWER,
    payload: {
      appointment
    }
  });
};

export const _setEligibilityVerificationNetworkPatientDrawer = (
  eligibilityNetwork: string | null
) => async (dispatch: any): Promise<void> => {
  dispatch({
    type: SET_ELIGIBILITY_NETWORK_APPOINTMENT_DRAWER,
    payload: {
      eligibilityNetwork
    }
  });
};
